module.exports = __webpack_public_path__ + "media/images/home/focus-bg3-ba959e213aff74d203144312df707dd6.png";